import BreadcrumbTitle from "components/BreadcrumbTitle"
import ModalComponent from "components/Modals"
import PageMetaTags from "components/PageMetaTags"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Container,
  Nav,
  NavLink,
  Row,
  Col,
  Card,
  CardBody,
  TabContent,
  TabPane,
} from "reactstrap"
import {
  getAllCalendars,
  getBusinessUnits,
  getBookingCalendars,
  hideCreateBookingModal,
  resetBookingFeature,
} from "store/actions"
import CreateBookingForm from "./createBookingForm"
import ManageCalendarsTab from "./manageCalendarsTab"
import ScheduledEventTab from "./scheduledEventTab"

const BookingCalendar = ({
  getBookingCalendars,
  getBusinessUnits,
  getAllCalendars,
  createBookingModalIsOpen,
  hideCreateBookingModal,
  resetBookingFeature,
}) => {
  const TABS = {
    SCHEDULED_BOOKINGS: 1,
    MANAGE_CALENDARS: 2,
  }

  const DEFAULT_BREADCRUMB_ITEMS = [
    { title: "Dashboard" },
    {
      title: "Scheduling Module",
      type: "tab",
      clickHandler: () => {
        setActiveTab(TABS.SCHEDULED_BOOKINGS)
      },
    },
  ]

  useEffect(() => {
    getBookingCalendars({ type: 2 })
    getBusinessUnits()
    getAllCalendars({ type: 2 })
    return () => {
      resetBookingFeature()
    }
  }, [])

  const [activeTab, setActiveTab] = useState(TABS.SCHEDULED_BOOKINGS)

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  const [bookingCalendar, setBookingCalendar] = useState()
  const [bookingSubCalendar, setBookingSubCalendar] = useState()

  const moment = require("moment-timezone")

  const [breadcrumbItems, setBreadcrumbItems] = useState(
    DEFAULT_BREADCRUMB_ITEMS
  )

  useEffect(() => {
    setBreadcrumbItems([
      ...DEFAULT_BREADCRUMB_ITEMS,
      { title: activeTab === 1 ? "Scheduled Bookings" : "Manage Calendars" },
    ])
  }, [activeTab])

  const setSubTabBreadcrumb = items => {
    setBreadcrumbItems([...DEFAULT_BREADCRUMB_ITEMS, ...items])
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Bookings" />
        <Container fluid>
          <BreadcrumbTitle title="Booking" breadcrumbItems={breadcrumbItems} />
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <Nav pills tabs>
                    <NavLink
                      className={markIfIsActive(TABS.SCHEDULED_BOOKINGS)}
                      onClick={() => setActiveTab(TABS.SCHEDULED_BOOKINGS)}
                    >
                      {
                        <span style={{ fontSize: "16px" }}>
                          Scheduled Bookings
                        </span>
                      }
                    </NavLink>
                    <NavLink
                      className={markIfIsActive(TABS.MANAGE_CALENDARS)}
                      onClick={() => setActiveTab(TABS.MANAGE_CALENDARS)}
                    >
                      {
                        <span style={{ fontSize: "16px" }}>
                          Manage Calendars
                        </span>
                      }
                    </NavLink>
                  </Nav>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId={TABS.SCHEDULED_BOOKINGS}>
                      <ScheduledEventTab
                        tabIsActive={activeTab === TABS.SCHEDULED_BOOKINGS}
                      />
                    </TabPane>
                    <TabPane tabId={TABS.MANAGE_CALENDARS}>
                      <ManageCalendarsTab
                        tabIsActive={activeTab === TABS.MANAGE_CALENDARS}
                        setBookingCalendar={setBookingCalendar}
                        setBookingSubCalendar={setBookingSubCalendar}
                        setSubTabBreadcrumb={setSubTabBreadcrumb}
                      />
                    </TabPane>
                  </TabContent>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
        <ModalComponent
          open={createBookingModalIsOpen}
          onClose={hideCreateBookingModal}
          title="Create Booking"
          size="xl"
          style={{ maxWidth: "800px" }}
        >
          <CreateBookingForm
            initialValues={{
              calendar: bookingCalendar?.id,
              subCalendar: bookingSubCalendar?.id,
              timeType: "AM",
              paymentType: "0",
              timezone: moment.tz.guess(),
            }}
            setBookingCalendar={setBookingCalendar}
            setBookingSubCalendar={setBookingSubCalendar}
            initialCalendarId={bookingCalendar?.id}
          />
        </ModalComponent>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  createBookingModalIsOpen: state.BookingsFeature.createBookingModalIsOpen,
})

const mapDispatchToProps = dispatch => ({
  getBookingCalendars: values => dispatch(getBookingCalendars(values)),
  getBusinessUnits: values => dispatch(getBusinessUnits(values)),
  getAllCalendars: values => dispatch(getAllCalendars(values)),
  hideCreateBookingModal: () => dispatch(hideCreateBookingModal()),
  resetBookingFeature: () => dispatch(resetBookingFeature()),
})

export default connect(mapStateToProps, mapDispatchToProps)(BookingCalendar)
